@if (skogsvardTradslag) {
  <div class="d-flex">
    @if (allatradslag?.length > 0) {
      <div>
        <rask-selector
          label="trädslag"
          [values]="allatradslag"
          [(ngModel)]="valttradslag"
          [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
          [exclude]="excludedTradslag()"
          placeholder="Välj trädslag"
          (change)="tradslagChanged($event)"
          [viewFormatter]="viewFormatter">
        </rask-selector>
      </div>
    }
    <div>
      <rask-input-number
        label="Arealsandel"
        [(ngModel)]="skogsvardTradslag.arealandel"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        (change)="arealandelChanged($event)"
        inputGroupRight="%"
        [min]="0"
        [max]="100"
        [useDecimalProcessor]="true"
        [isDecimal]="false">
      </rask-input-number>
    </div>
    @if (skogsvardTradslag.antalPlantor)
      {
      <div>
        <rask-input-number
          label="Antal träd (PL/ha)"
          [(ngModel)]="skogsvardTradslag.antalPlantor"
          [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
          (change)="antalPlantorChanged($event)"
          [isDecimal]="false"
          [min]="0"
          [useDecimalProcessor]="true">
        </rask-input-number>
      </div>
    }
    @else
    {
    <div>
      <rask-input-number
        label="Antal frön (kg/ha)"
        [(ngModel)]="skogsvardTradslag.frogiva"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        (change)="frogivaChanged($event)"
        [isDecimal]="true"
        [min]="0"
        [useDecimalProcessor]="true">
      </rask-input-number>
    </div>
  }
  <div class="d-flex">
    <div class="mt-auto delete-width">
      <rask-icon-button [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly" (click)="delete()"
      icon="far fa-trash-alt" negative></rask-icon-button>
    </div>
  </div>
</div>
}